import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DropDownFormControl } from './dropdown-form-control';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-dropdown-form-control',
  templateUrl: './dropdown-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownFormControlComponent),
      multi: true
    }
  ]
})
export class DropDownFormControlComponent
  extends AbstractFormControlComponent<DropDownFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() floatLabel: string;
  @Input() placeholder: string;
  @Input() inline: boolean;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  faClose: any = faTimes;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(value: any): void {
    this.onChanged.emit(value);
  }

  selectOpened(value: any): void {
    if (value !== 0) {
      this.collection.forEach(element => {
        if (element[this.keyPropertyName] === value) {
          document.querySelectorAll('.dropdown-item-class').forEach(item => {
            if (item.getAttribute('id') === value.toString()) {
              item.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          });
        }
      });
    }
  }

  public get isInline(): boolean {
    return this.inline || false;
  }

  public get placeholderText(): string {
    return this.placeholder || '';
  }

  public get floatLabelText(): string {
    return this.floatLabel || 'always';
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get collection(): any[] {
    return this.control.collection || [];
  }

  public get hiddenOptions(): any[] {
    return this.control.hiddenOptions || [];
  }

  public get keyPropertyName(): string {
    return this.control.keyPropertyName || 'name';
  }

  public get valuePropertyName(): string {
    return this.control.valuePropertyName || 'name';
  }

  public get disableChooseOption(): boolean {
    return this.control.disableChooseOption || false;
  }

  public get hideErrorMessages(): boolean {
    return this.control.hideErrorMessages || false;
  }

  public get hideErrorMark(): boolean {
    return this.control.hideErrorMark || true;
  }
  public get matOptionAutoHeight(): boolean {
    return this.control.matOptionAutoHeight || false;
  }
}
